import React, { useState } from 'react';
import { WellbeingData } from '../../../types/wellbeing';
import { NotesIcon } from '../CategoryIcons';

interface OtherModalProps {
  data: WellbeingData;
  onSave: (data: Partial<WellbeingData>) => void;
  onClose: () => void;
}

export const OtherModal: React.FC<OtherModalProps> = ({ data, onSave, onClose }) => {
  const [localData, setLocalData] = useState({
    physicalActivity: data.physicalActivity ?? 0,
    weight: data.weight ?? 0,
    fever: data.fever ?? false,
    temperature: data.temperature ?? undefined,
    notes: data.notes ?? '',
  });

  const Slider = ({
    label,
    value,
    onChange
  }: {
    label: string;
    value: number;
    onChange: (val: number) => void;
  }) => (
    <div style={{ marginBottom: '16px' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '6px',
      }}>
        <label style={{ fontSize: '13px', fontWeight: '600', color: '#0f172a' }}>
          {label}
        </label>
        <span style={{ fontSize: '13px', fontWeight: '600', color: '#6B7FFF' }}>
          {value}/5
        </span>
      </div>
      <input
        type="range"
        min="0"
        max="5"
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value))}
        style={{
          width: '100%',
          height: '6px',
          cursor: 'pointer',
          accentColor: '#6B7FFF',
        }}
      />
    </div>
  );

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: '20px',
        paddingTop: '60px',
        overflowY: 'auto',
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: '20px',
          padding: '24px',
          maxWidth: '500px',
          width: '100%',
          maxHeight: 'calc(100vh - 120px)',
          overflowY: 'auto',
          position: 'relative',
          marginBottom: '40px',
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '20px',
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '10px',
            background: 'linear-gradient(135deg, #f0f4ff 0%, #e0e7ff 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <NotesIcon />
          </div>

          <h2 style={{
            fontSize: '20px',
            fontWeight: '700',
            color: '#0f172a',
            margin: 0,
          }}>
            Inne
          </h2>
        </div>

        <Slider
          label="Aktywność fizyczna"
          value={localData.physicalActivity}
          onChange={(v) => setLocalData({ ...localData, physicalActivity: v })}
        />

        <div style={{ marginBottom: '16px' }}>
          <label style={{
            display: 'block',
            fontSize: '13px',
            fontWeight: '600',
            color: '#0f172a',
            marginBottom: '6px',
          }}>
            Waga (kg)
          </label>
          <input
            type="number"
            step="0.1"
            min="0"
            value={localData.weight || ''}
            onChange={(e) => setLocalData({ ...localData, weight: parseFloat(e.target.value) || 0 })}
            placeholder="65.5"
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '14px',
              borderRadius: '10px',
              border: '2px solid #e2e8f0',
              outline: 'none',
            }}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '12px',
            borderRadius: '10px',
            border: '2px solid #e2e8f0',
            cursor: 'pointer',
            background: localData.fever ? '#f0f4ff' : 'white',
            marginBottom: '8px',
          }}>
            <input
              type="checkbox"
              checked={localData.fever}
              onChange={(e) => setLocalData({ ...localData, fever: e.target.checked })}
              style={{
                width: '18px',
                height: '18px',
                cursor: 'pointer',
                accentColor: '#6B7FFF',
              }}
            />
            <span style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#0f172a',
            }}>
              Gorączka
            </span>
          </label>

          {localData.fever && (
            <input
              type="number"
              step="0.1"
              min="35"
              max="42"
              value={localData.temperature || ''}
              onChange={(e) => {
                const val = e.target.value;
                setLocalData({ ...localData, temperature: val === '' ? undefined : parseFloat(val) });
              }}
              placeholder="38.2"
              style={{
                width: '100%',
                padding: '10px',
                fontSize: '14px',
                borderRadius: '10px',
                border: '2px solid #e2e8f0',
                outline: 'none',
              }}
            />
          )}
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            fontSize: '13px',
            fontWeight: '600',
            color: '#0f172a',
            marginBottom: '6px',
          }}>
            Notatki ogólne
          </label>
          <textarea
            value={localData.notes}
            onChange={(e) => setLocalData({ ...localData, notes: e.target.value })}
            placeholder="Dodatkowe uwagi..."
            rows={3}
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '14px',
              borderRadius: '10px',
              border: '2px solid #e2e8f0',
              outline: 'none',
              resize: 'vertical',
              fontFamily: 'inherit',
            }}
          />
        </div>

        <button
          onClick={() => onSave(localData)}
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '10px',
            border: 'none',
            background: 'linear-gradient(135deg, #6B7FFF 0%, #5A6EE6 100%)',
            color: 'white',
            fontSize: '15px',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Gotowe ✓
        </button>
      </div>
    </div>
  );
};
